var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolitics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.21 16.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-956.41 -527.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M956.41 527.51h16.21v16.21h-16.21z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11 15.7a7.6 7.6 0 10-7.6-7.6 7.6 7.6 0 007.6 7.6",
    fill: "#00393f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 8.1,
    r: 7.6,
    stroke: "#c33200",
    strokeWidth: 1.01,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 8.4h2.13v2.13H7.04zm0-4.3h2.13v2.13H7.04zM3.7 8.4h2.12v2.13H3.7zm6.68 0h2.13v2.13h-2.13z",
    fill: "#c33200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitics);
export default __webpack_public_path__ + "static/media/politics.92685ceb.svg";
export { ForwardRef as ReactComponent };